import {ConfigContext} from '../../config/context/index.js'
import {ListSharedValueObject} from '../../shared/ValueObjects/ListSharedValueObject.js'
import {BodyTypeSpecificationVehiclesValueObject} from './BodyTypeSpecificationVehiclesValueObject.js'

export class ListBodyTypesOptionsValueObject extends ListSharedValueObject {
  constructor({value}) {
    super({value})
  }

  static createFromApiResponse({items}) {
    this.validate({value: items})
    const defaultCulture = ConfigContext.get('DEFAULT_CULTURE')
    const bodyTypesTranslations = ConfigContext.get('tracking').BODY_TYPES_TRANSLATIONS

    const bodyTypes = items.map(item =>
      BodyTypeSpecificationVehiclesValueObject.createFromLiterals({
        id: item.bodyTypeId,
        name: bodyTypesTranslations[item.bodyTypeId][defaultCulture] || item.name
      })
    )

    return new ListBodyTypesOptionsValueObject({value: bodyTypes})
  }

  getFilterOptions() {
    return this.value.map(bodyType => {
      const {id, name} = bodyType
      return {
        id,
        value: id,
        label: name
      }
    })
  }
}
